import React, { useEffect, useState, useRef, useContext } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import baseURL from "../Apiurs/Apiurls";
import Navbar from "../Shared/AdminNavbar/Navbar";
import { AuthContext } from "../AuthContext/Authcontext";
import { Tabs, Tab } from "react-bootstrap";
import CustomQuillEditor from "./CustomQullier";
import "./Email.css";
import { FiMail, FiPhone, FiUser } from "react-icons/fi";

const RegretEmail = () => {
  const { leadid } = useParams();
  const { userEmail } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  const { email, lead } = location.state || {};
  
  const [emailHistory, setEmailHistory] = useState([]);
  const [text, setText] = useState("");
  const [subject, setSubject] = useState("Regret Email");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const chatEndRef = useRef(null);
  const [collapsed, setCollapsed] = useState(false);
  const [receiverEmails, setReceiverEmails] = useState(email || "");
  const [ccEmails, setCcEmails] = useState("");
  const [bccEmails, setBccEmails] = useState("");
  const [showCC, setShowCC] = useState(false);
  const [showBCC, setShowBCC] = useState(false);
  const [latestMessageId, setLatestMessageId] = useState("");
  const [originalEmailContent, setOriginalEmailContent] = useState(""); // NEW: Store original email content

  // Fetch email history and get the latest message_id
  const fetchEmailHistory = async () => {
    try {
      const response = await axios.get(`${baseURL}/api/email-history/${leadid}`);
      if (response.data.success) {
        const filteredHistory = response.data.data.map(email => ({
          id: email.id,
          sender_email: email.sender_email,
          receiver_email: email.receiver_email,
          subject: email.subject,
          text: email.text,
          file_path: email.file_path,
          type: email.type,
          created_at: email.created_at,
          message_id: email.message_id
        }));
        setEmailHistory(filteredHistory);
        
        // Get the latest message_id for email threading and original content
        if (filteredHistory.length > 0) {
          const latestEmail = filteredHistory[0];
          setLatestMessageId(latestEmail.message_id || "");
          
          // NEW: Store original email content for reply
          setOriginalEmailContent(latestEmail.text || "");
          
          // NEW: Set subject with "Re:" prefix if it's not already there
          const currentSubject = latestEmail.subject || "Regret Email";
          if (!currentSubject.toLowerCase().startsWith("re:")) {
            setSubject(`Re: ${currentSubject}`);
          } else {
            setSubject(currentSubject);
          }
          
          // NEW: Set receiver email from the latest email's sender
          if (latestEmail.sender_email) {
            setReceiverEmails(latestEmail.sender_email);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching email history:", error);
    }
  };

  useEffect(() => {
    fetchEmailHistory();
  }, [leadid]);

  // NEW: Function to format reply content with original message
  const formatReplyContent = (newText, originalText) => {
    if (!originalText) return newText;
    
    const timestamp = new Date().toLocaleString();
    const replySeparator = `<br><br><hr style="border: 1px solid #e0e0e0; margin: 20px 0;"><div style="color: #666; font-size: 14px; padding: 10px; background: #f9f9f9; border-left: 4px solid #ccc;">`;
    const originalHeader = `<strong>Original Message:</strong><br>`;
    const originalContent = `<div style="margin-top: 10px;">${originalText}</div></div>`;
    
    return `${newText}${replySeparator}${originalHeader}${originalContent}`;
  };

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    const validFiles = files.filter(file => {
      if (file.size > 2 * 1024 * 1024) {
        alert(`File ${file.name} must be below 2MB.`);
        return false;
      }
      return true;
    });
    setSelectedFiles(prev => [...prev, ...validFiles]);
  };

  const removeFile = (index) => {
    setSelectedFiles(prev => prev.filter((_, i) => i !== index));
  };

  const handleSendRegretEmail = async () => {
    if (!text && selectedFiles.length === 0) {
      alert("Please enter a message or upload files.");
      return;
    }

    if (!userEmail) {
      alert("Sender email not found. Please log in again.");
      return;
    }

    const receivers = receiverEmails.split(",").map(email => email.trim()).filter(Boolean);
    if (receivers.length === 0) {
      alert("Please enter at least one recipient email.");
      return;
    }

    const cc = showCC ? ccEmails.split(",").map(email => email.trim()).filter(Boolean) : [];
    const bcc = showBCC ? bccEmails.split(",").map(email => email.trim()).filter(Boolean) : [];

    setLoading(true);

    // NEW: Format the content as a reply
    const formattedText = formatReplyContent(text, originalEmailContent);

    const formData = new FormData();
    formData.append("leadid", leadid);
    formData.append("sender_email", userEmail);
    formData.append("text", formattedText); // CHANGED: Use formatted reply text
    formData.append("subject", subject || "Regret Email");
    formData.append("type", "sent");
    formData.append("is_plain_text", "false");
    formData.append("receiver_emails", JSON.stringify(receivers));
    if (showCC) formData.append("cc_emails", JSON.stringify(cc));
    if (showBCC) formData.append("bcc_emails", JSON.stringify(bcc));
    formData.append("is_regret_email", "true");
    
    // Add message_id for email threading (this makes it a reply)
    if (latestMessageId) {
      formData.append("message_id", latestMessageId);
    }

    // Add lead information
    if (lead) {
      formData.append("leadInfo", JSON.stringify({
        lead_name: lead.lead_name,
        business_name: lead.business_name,
        email: lead.email,
        contact_number: lead.contact_number,
        status: lead.status,
        opp_status: lead.opp_status
      }));
    }

    // Add all files
    selectedFiles.forEach(file => {
      formData.append("files", file);
    });

    try {
      const response = await axios.post(
        `${baseURL}/api/send-regret-email`, 
        formData, 
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (response.data.success) {
        alert("Regret email sent successfully as a reply!");
        
        // Reset form
        setText("");
        setSubject("Regret Email");
        setCcEmails("");
        setBccEmails("");
        setSelectedFiles([]);
        
        // Navigate back
        navigate(-1);
      } else {
        alert("Failed to send regret email: " + (response.data.error || "Unknown error"));
      }
    } catch (error) {
      console.error("Error sending regret email:", error);
      alert("Failed to send regret email. Please try again.");
    }

    setLoading(false);
  };

  const cleanEmailText = (text) => {
    if (!text) return "";
    const cleanedText = text.split(/\n?On\s.+\s(?:at|wrote:)/i)[0];
    return cleanedText.replace(/--\sThis email has been checked for viruses.*/is, "").trim();
  };

  return (
    <div className="CollapseContainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`Collapse ${collapsed ? "collapsed" : ""}`}>
        <div className="email-content-inner">
          {/* Header Section - Similar to ViewLead */}
          <div className="adminviewproducts-viewlead-container-fluid adminviewproducts-viewlead-py-2 px-5">
            <div className="adminviewproducts-viewlead-d-flex adminviewproducts-viewlead-align-items-center adminviewproducts-viewlead-justify-content-between">
              {/* Left Side: Profile + Name + Email + Phone */}
              <div className="adminviewproducts-viewlead-d-flex adminviewproducts-viewlead-align-items-center">
                {/* Profile Circle */}
                <div className="adminviewproducts-viewlead-avatar-circle adminviewproducts-viewlead-bg-primary adminviewproducts-viewlead-text-white">
                  {lead?.lead_name ? lead.lead_name.charAt(0).toUpperCase() : "L"}
                </div>

                {/* Name + Email + Phone beside profile */}
                <div className="adminviewproducts-viewlead-d-flex adminviewproducts-viewlead-align-items-center" style={{ gap: "20px" }}>
                  {/* Lead Name */}
                  {lead?.lead_name && (
                    <div className="adminviewproducts-viewlead-lead-detail-item">
                      <FiUser className="adminviewproducts-viewlead-me-2 adminviewproducts-viewlead-text-muted" />
                      <span>{lead.lead_name}</span>
                    </div>
                  )}

                  {/* Email */}
                  <div className="adminviewproducts-viewlead-lead-detail-item">
                    <FiMail className="adminviewproducts-viewlead-me-2 adminviewproducts-viewlead-text-muted" />
                    <span>{lead?.email || email || "N/A"}</span>
                  </div>

                  {/* Phone */}
                  <div className="adminviewproducts-viewlead-lead-detail-item">
                    <FiPhone className="adminviewproducts-viewlead-me-2 adminviewproducts-viewlead-text-muted" />
                    <span>{lead?.contact_number || "N/A"}</span>
                  </div>
                </div>
              </div>

              {/* Right Side: Status or Additional Info */}
              <div className="flex gap-2">
                <span className="badge bg-warning text-dark px-3 py-2">
                  Regret Email (Reply)
                </span>
              </div>
            </div>
          </div>

          {/* Email History Section */}
          <div className="email-history-section">
            {/* Email history content remains the same */}
          </div>

          {/* Regret Email Form Section */}
          <div className="email-form-section">
            <div className="email-form-card">
              <h3 className="email-form-title">Send Regret Email as Reply</h3>
              
              <div className="email-form-group">
                <label className="email-form-label">To:</label>
                <textarea
                  placeholder="Enter recipient emails (comma separated)"
                  value={receiverEmails}
                  onChange={(e) => setReceiverEmails(e.target.value)}
                  className="email-input-receivers"
                />
              </div>

              <div className="email-form-group">
                <label className="email-form-label">Subject:</label>
                <input
                  type="text"
                  placeholder="Enter Subject"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  className="email-input-subject"
                />
              </div>
              
              <div className="email-form-group">
                <label className="email-form-label">Message:</label>
                <CustomQuillEditor
                  value={text}
                  onChange={setText}
                  className="email-rich-text-editor"
                  placeholder="Enter your regret message here... (The original email will be automatically included below your message)"
                />
              </div>
              
              {/* NEW: Show original email preview */}
              {originalEmailContent && (
                <div className="email-form-group">
                  <label className="email-form-label">Original Email Preview:</label>
                  <div 
                    className="original-email-preview"
                    style={{
                      padding: "10px",
                      backgroundColor: "#f9f9f9",
                      border: "1px solid #e0e0e0",
                      borderRadius: "4px",
                      maxHeight: "200px",
                      overflowY: "auto",
                      fontSize: "14px",
                      color: "#666"
                    }}
                    dangerouslySetInnerHTML={{ __html: originalEmailContent }}
                  />
                  <small className="text-muted">
                    This original email will be automatically included below your reply message.
                  </small>
                </div>
              )}
              
              <div className="email-form-group">
                <label className="email-form-label">Attachments:</label>
                <input
                  type="file"
                  onChange={handleFileChange}
                  className="email-file-input"
                  multiple
                />
                {/* {selectedFiles.length > 0 && (
                  <div className="selected-files mt-2">
                    <strong>Selected files:</strong>
                    {selectedFiles.map((file, index) => (
                      <div key={index} className="file-item d-flex align-items-center mt-1">
                        <span className="me-2">📎 {file.name}</span>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => removeFile(index)}
                        >
                          Remove
                        </button>
                      </div>
                    ))}
                  </div>
                )} */}
              </div>
              
              <button
                onClick={handleSendRegretEmail}
                disabled={loading}
                className="email-send-button btn-warning"
              >
                {loading ? "Sending Regret Email as Reply..." : "Send Regret Email as Reply"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegretEmail;